export const SERVICE_SOLUTION_SUCCESS = 'SERVICE_SOLUTION_SUCCESS'
export const SERVICE_SOLUTION_FAILURE = 'SERVICE_SOLUTION_FAILURE'

export const serviceSolutionData = (serviceSolution) =>{
  return (dispatch, getState) => {
    dispatch({ type: SERVICE_SOLUTION_SUCCESS,serviceSolution });
  }
}
